<template>
  <div class="page-compact">
    <crm-panel :title="'回款列表'">
      <div class="page-buttons">
        <crm-button
          v-if="auth.paybackDelete && auth.paybackDelete.toggleStatus"
          :buttonType="'plain'"
          :text="'批量删除'"
          @click="handleMoreDelete()"
        >
        </crm-button>
        <crm-button
          v-if="auth.paybackImport && auth.paybackImport.toggleStatus"
          :buttonType="'plain'"
          :text="'导入'"
          :disabled="isImportDisabled"
          @click="handleImport()"
        >
        </crm-button>
        <crm-button
          v-if="auth.paybackExport && auth.paybackExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          :disabled="isExportDisabled"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <payback-search ref="paybackSearchRef" @handle-search="handleSearchListData" />
      </div>
      <!-- 回款列表 -->
      <el-table
        :data="list.results"
        height="100%"
        v-loading="loading"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          :selectable="handleGetStatus"
        />

        <el-table-column fixed="left" prop="refundType" align="center" label="回款类型" />
        <el-table-column
          fixed="left"
          prop="refundAmount"
          align="center"
          label="回款金额"
        />

        <el-table-column
          prop="refundDate"
          align="center"
          label="回款日期"
          width="150px"
        />

        <el-table-column prop="refundInstallment" align="center" label="回款期数" />
        <el-table-column
          show-overflow-tooltip
          prop="customerName"
          align="center"
          label="客户名称"
          width="180px"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCustomClick(scope)">{{
              scope.row.customerName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="customerPayBank"
          align="center"
          label="客户打款银行"
          width="180px"
        />

        <el-table-column
          show-overflow-tooltip
          prop="customerPayAccount"
          align="center"
          label="客户银行账号"
          width="180px"
        />

        <el-table-column
          show-overflow-tooltip
          prop="myReceivableCompany"
          align="center"
          label="我方收款公司"
          width="180px"
        />

        <el-table-column
          show-overflow-tooltip
          prop="myReceivableBank"
          align="center"
          label="我方收款银行"
          width="180px"
        />

        <el-table-column
          show-overflow-tooltip
          label="我方收款账号"
          align="center"
          prop="myReceivableAccount"
          width="180px"
        />

        <el-table-column
          show-overflow-tooltip
          label="合同编号"
          align="center"
          width="150px"
        >
          <template slot-scope="scope">
            <span class="link" @click="handleCompactDetailShow(scope)">{{
              scope.row.contractNo
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contractAmount" align="center" label="合同金额" />

        <el-table-column
          show-overflow-tooltip
          prop="minimumBudgetUnit"
          align="center"
          label="最小预算单元"
          width="150px"
        />

        <el-table-column
          prop="firstAccountDept"
          align="center"
          label="一级结算部门"
          width="150px"
        />

        <el-table-column
          show-overflow-tooltip
          prop="businessAccountDept"
          align="center"
          label="业务结算部门"
          width="150px"
        />

        <el-table-column prop="examineStatus" align="center" label="审核状态" />
        <el-table-column
            prop=""
            label="回单"
            align="center"
            width="150px"
            :show-overflow-tooltip="true"
        >
        <template #default="{row}">
            <el-button v-if="row.receiptLink" type="text" @click="handlePreviewUrl(row.receiptLink)">回单</el-button>
        </template>
      </el-table-column>


        <el-table-column
          prop="invoiceDate"
          align="center"
          label="开票日期"
          width="150px"
        />

        <el-table-column prop="invoiceAmount" align="center" label="开票金额" />
        <el-table-column prop="salesmanName" align="center" label="业务员" />
        <el-table-column prop="teamName" align="center" label="团队" width="150px" />
        <el-table-column
          prop="updateTimeStr"
          align="center"
          label="更新时间"
          width="150px"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updateTimeStr || scope.row.createTimeStr }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTimeStr"
          align="center"
          label="创建时间"
          width="150px"
        />

        <el-table-column label="操作" align="center" width="220px">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="handleDetail(row.id)"
              >查看</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleEdit(row)"
              :disabled="row.examineStatus === '待入账' || row.examineStatus === '已入账'"
              >编辑</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="handleDelete(row.id)"
              :disabled="row.examineStatus === '待入账' || row.examineStatus === '已入账'"
              >删除</el-button
            >
            <el-button
              v-if="
               customAuth.customerUpdateSalesman &&
                  customAuth.customerUpdateSalesman.toggleStatus
              "
              @click="handleShowChangeSalesman(row)"
              type="text"
              size="small"
            >
              替换业务员
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 回款列表分页 -->
      <div class="pageination">
        <div class="info-wrap" v-if="envCrm">
          <p>
            <span class="info-title">回款总额：</span>
            <span class="info-detail">{{ payBackCount.receivableAmount }}元</span>
            <span class="info-title">已确认总额：</span>
            <span class="info-detail">{{ payBackCount.confirmReceivableAmount }}元</span>
            <span class="info-title">待确认总额：</span>
            <span class="info-detail">{{ payBackCount.waitConfirmReceivableAmount }}元</span>
          </p>
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="list.totalCount || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <!-- 合同详情侧面板 -->
    <transition name="slide-fade">
      <template v-if="envCrm">
        <div v-show="compactDetailVisibleInside">
          <compact-detail-inside
            :row="row"
            :detailId="detailId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail-inside>
        </div>
      </template>
      <template v-else>
        <div v-show="compactDetailVisible">
          <compact-detail
            :detailId="detailId"
            :detailTabName="detailTabName"
            @handleCloseDetail="handleCloseCompactDetail"
          >
          </compact-detail>
        </div>
      </template>
    </transition>

    <!-- 客户详情侧面板 -->
    <we-custom-details
      v-if="customDetailShow"
      v-bind="viewPanel"
      :sourcePart="'customer'"
      @closeCustomDetail="closeCustomDetail"
      @saveEditCustom="handleSearch"
      @success="handleSearch()"
    >
    </we-custom-details>

    <crm-upload
      :visible="isShowUplaod"
      :upload="upload"
      :handleClose="handleCloseUpload"
      download="/api/receivableManagement/downloadTemp"
    />

    <!-- 回款详情 -->
    <payback-detail ref="paybackDetailRef" />
    <!-- 回款弹窗 -->
    <paybackDialog
      ref="paybackDialogRef"
      @handle-success-payback="handleSearchListData(true)"
    />
    <!-- 业务员修改对话框 -->
    <el-dialog
      :title="dialogUpdateSalesman.title"
      width="30%"
      @close="handleCloseSalesman()"
      :visible.sync="dialogUpdateSalesman.visible"
    >
      <el-form :model="updateSalesmanForm" label-width="120px" ref="updateSalesmanForm">
        <el-form-item
          label="当前业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择当前业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.code"
            placeholder="请选择当前业务员"
          >
            <el-option
              v-for="item in currrntSalesmanList"
              :label="item.salesmanName"
              :value="item.salesmanCode"
              :key="item.salesmanCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="替换后业务员:"
          prop="newCode"
          :rules="{
            required: true,
            message: '请选择替换后业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="updateSalesmanForm.newCode"
            placeholder="请选择替换后业务员"
          >
            <el-option
              v-for="item in salesmanList"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <crm-button
          :buttonType="'plain'"
          :text="'取消'"
          @click="handleCloseSalesman()"
        >
        </crm-button>
        <crm-button :text="'确定'" @click="handleupdateCustomSalesman()"> </crm-button>
      </div>
    </el-dialog>

    <pdf-view ref="pdfView"/>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import config from "~config";
import { downloadByUrl, newDownloadByUrl, isEmptyObj } from "@/scripts/utils";
import crmPanel from "@/components/base/crmPanel";
import pdfView from "@/components/base/pdf-view";
import crmButton from "@/components/base/crmButton";
import crmUpload from "@/components/base/crmUpload";
import WeSearchInputTypeOptions from "~component/business/compact/search-input-type-options";
import WeCustomDetails from "~component/business/custom/customDetails.vue";
import CompactDetail from "~component/business/compact/detail.vue";
import paybackSearch from "./payback-search";
import paybackDetail from "@/components/business/compact/payback-detail.vue";
import paybackDialog from "@/components/business/compact/paybackDialog.vue/";
import services from "@/services/api/compact";
import cookie from "js-cookie";
import CompactDetailInside from "@/pages/compact-inside/component";

export default {
  provide() {
    return { info: this.info };
  },
  components: {
    WeSearchInputTypeOptions,
    CompactDetail,
    CompactDetailInside,
    WeCustomDetails,
    crmPanel,
    crmButton,
    crmUpload,
    paybackSearch,
    paybackDetail,
    paybackDialog,
    pdfView,
  },
  data() {
    return {
      list: {},
      loading: false,
      isImportDisabled: false, // 导入按钮
      isExportDisabled: false, // 导出按钮
      isShowUplaod: false,
      searchDate: {
        // 日期搜索
        createdStartDate: null,
        createdEndDate: null,
        refundStartDate: null,
        refundEndDate: null,
      },
      searchForm: {
        // 名字搜索
        customerName: null,
        customerNo: null,
        contractNo: null,
        salesmanName: null,
      },
      searchDateType: 1,
      searchTime: [],
      searchName: "",
      searchNameType: "customerName",
      // 列表选中项
      multipleSelection: [],
      // 分页
      pagenation: {
        pageNumber: 1,
        pageSize: 10,
      },
      // 合同详情
      compactDetailVisible: false,
      detailId: null,
      detailTabName: null,
      // 查看客户详情
      customDetailShow: false,
      // 客户查看面板
      customRow: {},
      viewPanel: {
        uid: "",
        type: 1,
        teamId: 1,
        authEdit: true,
        authDelete: true,
      },
      payBackCount: {
        confirmReceivableAmount: '',
        receivableAmount: '',
        waitConfirmReceivableAmount: '',
      },
      envCrm: cookie.get("_env_crm__") !== "false",
      // 业务员修改对话框
      dialogUpdateSalesman: {
        visible: false,
        title: null,
        isBatch: null,
      },
      // 业务员修改表单
      updateSalesmanForm: {
        id: '',
        newCode: "",
        code: "",
      },
      currrntSalesmanList: [],
      envCrm: cookie.get("_env_crm__") !== "false",
      row: {},
      compactDetailVisibleInside: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      customAuth: "authority/customAuth",
      moneyBackData: "compact/moneyBackData",
      customDetail: "customer/customDetail",
      salesmanList: "common/clerkList",
    }),
  },
  mounted() {
    if (JSON.stringify(this.$route.params) !== "{}") {
      this.searchDateType = this.$route.params.searchDateType
        ? this.$route.params.searchDateType
        : 1;
      this.searchTime = this.$route.params.searchTime
        ? this.$route.params.searchTime
        : [];
    }
    this.handleSearchListData();
    if (Object.keys(this.customAuth).length === 0)
      this.getAuthority({ menuUrl: "/customer/valid" });
  },
  methods: {
    ...mapActions({
      getAuthority: "authority/getAuthority",
      getMoneyBackData: "compact/getMoneyBackData",
      upload: "compact/upload",
      apiMoneyDelete: "compact/apiMoneyDelete",
      apiMoneyDeletelist: "compact/apiMoneyDeletelist",
      getCustomDetail: "customer/getCustomDetail",
      getClerkList: "common/getClerkList",
      getSalesmanList: "customer/getSalesmanList",
    }),
    handleGetStatus(row) {
      return !(row.examineStatus === "待入账" || row.examineStatus === "已入账");
    },
    async handleSearchListData(isSearch = false) {
      const key = this.$refs.paybackSearchRef.searchForm;
      const page = this.pagenation;
      if (isSearch) page.pageNumber = 1;
      const payload = { ...key, ...page };
      try {
        this.loading = true;
        const { data } = await services.apiQueryList({ ...payload });
        this.list = data;
        // 回款数据汇总
        const dataCount = await services.receivableCount({ ...payload });
        this.payBackCount = dataCount.data
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleDetail(id) {
      this.$refs.paybackDetailRef.handleOpenDetail(id);
    },
    handleEdit(row) {
      this.$refs.paybackDialogRef.handleEdit(row);
    },
    // 导入
    handleImport() {
      this.isImportDisabled = true;
      this.isShowUplaod = true;
    },
    handleCloseUpload() {
      this.isImportDisabled = false;
      this.isShowUplaod = false;
      this.handleSearchListData();
    },
    // 导出
    async handleExport() {
      this.isExportDisabled = true;
      const key = this.$refs.paybackSearchRef.searchForm;
      const payload = { ...key };
      let url = `${config.api || ""}/api/receivableManagement/export?`;
      Object.keys(payload).forEach((item) => {
        if (payload[item]) url += `${item}=${payload[item]}&`;
      });
      try {
        this.notify = this.$notify({
          iconClass: "el-icon-loading",
          title: "",
          message: "正在导出中，请稍后...",
          duration: 0,
          showClose: false,
        });
        await newDownloadByUrl(url);
        this.notify.close();
      } catch (error) {
        this.notify.close();
        this.$message.error(error.message);
      }
      this.isExportDisabled = false;
    },
    // 处理搜索数据
    handleSearchData() {
      this.searchDate = {
        createdStartDate: null,
        createdEndDate: null,
        refundStartDate: null,
        refundEndDate: null,
      };
      const dateList = ["refund", "created"];
      if (this.searchTime && this.searchTime.length > 0) {
        this.searchDate[
          `${dateList[this.searchDateType - 1]}StartDate`
        ] = this.searchTime[0];
        this.searchDate[
          `${dateList[this.searchDateType - 1]}EndDate`
        ] = this.searchTime[1];
      }

      const nameList = ["customerName", "customerNo", "contractNo", "salesmanName"];
      nameList.forEach((i) => {
        this.searchForm[i] = null;
      });
      if (this.searchName) this.searchForm[this.searchNameType] = this.searchName;
    },
    // 搜索按钮
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleSearchData();
      this.handleSearchListData();
    },
    // 根据条件刷新合同列表
    handleGetCompactList() {
      this.loading = true;
      this.getMoneyBackData({
        ...this.pagenation,
        ...this.searchForm,
        ...this.searchDate,
      }).finally(() => {
        this.loading = false;
      });
    },
    // 分页 每页显示条数
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleSearchListData();
    },
    // 分页，当前页改变
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleSearchListData();
    },
    // 合同详情
    handleCompactDetailShow(scope, tabName) {
      if (this.envCrm) {
        this.row = scope.row;
        this.detailId = scope.row.contractId;
        this.compactDetailVisibleInside = true;
        setTimeout(() => {
          this.detailTabName = tabName || null
        }, 10)
      } else {
        this.detailId = scope.row.contractId;
        this.compactDetailVisible = true;
        if (tabName) {
          this.detailTabName = tabName;
        } else {
          this.detailTabName = null;
        }
      }
    },
    handleCloseCompactDetail(isRefresh) {
      this.compactDetailVisible = false;
      this.compactDetailVisibleInside = false;
      this.detailTabName = ''
      if (isRefresh) {
        this.handleSearch();
      }
    },
    // 客户详情
    async handleCustomClick(scope) {
      if (scope.row.customerIsDeleted === 1) {
        this.$message({
          type: "error",
          message: "该客户不存在或已删除",
        });
      } else {
        await this.getCustomDetail({
          sourcePart: "customer",
          uid: scope.row.customerId,
        }).then(() => {
          if (!isEmptyObj(this.customDetail)) {
            this.customRow = scope.row;
            this.customDetailShow = true;
            this.viewPanel = Object.assign(this.viewPanel, {
              uid: scope.row.customerId,
              type: scope.row.customerType,
              teamId: scope.row.teamId,
              authEdit:
                !scope.row.searchUid && this.customAuth.customerUpdate.toggleStatus,
              authDelete: this.customAuth.customerDelete.toggleStatus,
            });
          }
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 删除
    handleDelete(id) {
      this.$confirm("该操作将删除所选回款记录，是否继续？", "操作确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        services.apiDeletePayback({ idList: [id] }).then(() => {
          this.$message.success("操作成功!");
          this.handleSearchListData();
        });
      });
    },
    // 批量删除
    handleMoreDelete() {
      const delDetailed = this.multipleSelection.map((v) => v.id);
      if (delDetailed.length) {
        this.$confirm("该操作将删除所选回款记录，是否继续？", "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          services.apiDeletePayback({ idList: delDetailed }).then(() => {
            this.$message.success("操作成功!");
            this.handleSearchListData(true);
          });
        });
      } else {
        this.$message.error("请选择要删除的回款记录");
      }
    },
    closeCustomDetail() {
      this.customDetailShow = false;
      this.handleSearch();
    },
    // 业务员
    handleShowChangeSalesman(row){
      if (this.salesmanList.length === 0) {
        this.getClerkList();
      }
      if (row) {
        this.getSalesmanList({
          customerUid: row.customerId,
          pageNumber: 1,
          pageSize: 100,
          sourcePart: "customer",
        });
      }
      this.updateSalesmanForm.id = row.id
      this.updateSalesmanForm.code = row.salesmanCode
      this.currrntSalesmanList = [{
        salesmanCode: row.salesmanCode,
        salesmanName: row.salesmanName,
      }]
      this.dialogUpdateSalesman = {
        visible: true,
        title: "替换业务员",
        isBatch: !row,
      };
    },
    // 取消修改业务员
    handleCloseSalesman() {
      this.dialogUpdateSalesman.visible = false;
      this.$refs.updateSalesmanForm.resetFields();
    },
    // 修改业务员
    handleupdateCustomSalesman() {
      this.$refs.updateSalesmanForm.validate().then((valid) => {
        if (valid) {
          services.updateSalesman({
            id: this.updateSalesmanForm.id,
            salesmanCode: this.updateSalesmanForm.newCode,
          })
            .then(() => {
              this.$message({
                message: "修改业务员成功",
                type: "success",
              });
              this.dialogUpdateSalesman.visible = false;
              return this.handleSearchListData();
            })
            .finally(() => {
              this.$refs.updateSalesmanForm.resetFields();
            });
        }
      });
    },
    handlePreviewUrl(url) {
        this.$refs.pdfView.open(url)
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/var.less";
@import "~@/styles/const.less";

.page-compact {
  display: flex;
  flex: 1;
  width: 100%;
  overflow: hidden;
  .el-checkbox {
    color: rgba(0, 0, 0, 0);
  }
}
</style>
